import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n";
import { IMAGES } from "../data/menu";
import { Reveal } from "./Reveal";

const Chapter = ({ num, title, text, img, reverse, ctaTo, ctaLabel, ctaTestid }) => (
  <div className={`grid md:grid-cols-2 gap-10 lg:gap-20 items-center ${reverse ? "md:[&>*:first-child]:order-2" : ""}`}>
    <Reveal>
      <div className="group relative overflow-hidden rounded-xl border border-line">
        <div className="absolute inset-0 bg-terra/0 group-hover:bg-terra/10 transition-colors duration-500 z-10 pointer-events-none" />
        <img
          src={img}
          alt={title}
          data-testid={`chapter-${num}-image`}
          className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
    </Reveal>
    <Reveal delay={0.15}>
      <span data-testid={`chapter-${num}-number`} className="font-serif text-[6rem] md:text-[8rem] leading-none text-transparent" style={{ WebkitTextStroke: "1px rgba(187,50,38,0.45)" }}>
        {num}
      </span>
      <h3 className="font-serif text-4xl md:text-5xl text-ink mt-2">{title}</h3>
      <p className="mt-5 max-w-md text-muted2 leading-relaxed font-light">{text}</p>
      <Link to={ctaTo} data-testid={ctaTestid} className="mt-8 inline-flex items-center gap-3 text-xs tracking-[0.22em] uppercase text-terra hover:gap-5 transition-all duration-300">
        {ctaLabel} <ArrowRight size={14} />
      </Link>
    </Reveal>
  </div>
);

export const Chapters = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="chapters-section" className="max-w-7xl mx-auto px-6 lg:px-10 py-28 md:py-40 space-y-28 md:space-y-40">
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase text-terra" data-testid="chapters-kicker">{t("chapters_kicker")}</p>
      </Reveal>
      <Chapter
        num="01"
        title={t("chapter_01_title")}
        text={t("chapter_01_text")}
        img={IMAGES.hero}
        ctaTo="/menu"
        ctaLabel={t("chapter_cta_menu")}
        ctaTestid="chapter-01-cta"
      />
      <Chapter
        num="02"
        title={t("chapter_02_title")}
        text={t("chapter_02_text")}
        img={IMAGES.interior}
        reverse
        ctaTo="/menu#ristorante"
        ctaLabel={t("chapter_cta_menu")}
        ctaTestid="chapter-02-cta"
      />
      <Chapter
        num="03"
        title={t("chapter_03_title")}
        text={t("chapter_03_text")}
        img={IMAGES.gelato}
        ctaTo="/gelateria"
        ctaLabel={t("chapter_cta_gelato")}
        ctaTestid="chapter-03-cta"
      />
    </section>
  );
};
